/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { FormGroup, AbstractControl, FormControl } from '@angular/forms';

// tslint:disable-next-line: class-name
export class validateStartPage {
  static createValidator(startPageControl: AbstractControl) {
    return (control: AbstractControl) => {

      // tslint:disable-next-line: object-literal-key-quotes
      // tslint:disable-next-line: radix
      return (+control.value) < (+startPageControl.value) ? { Smaller: true } : null;
    };
  }
}
